/* eslint-disable */
import React from 'react';
export const getClientDate = () => {
  const date = new Date();
  return `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()} ${date.getHours()}:${date.getMinutes()}`;
};


export const getValidationErrorMessage = (errorMessages, errors) => {
  return errors.map(validate => {
    if (Array.isArray(validate)) {
      let before_key = `${validate[0]}_before`;
      let after_key = `${validate[0]}_after`;
      return <p className="text-error" key={validate}>{`${errorMessages[before_key]} ${validate[1]} ${errorMessages[after_key]}`}</p>;
    }
    return <p className="text-error" key={validate}>{errorMessages[validate]}</p>;
  });
};  

export const GetFormRow = (field, form, errors, formSettings, inputField = true) => {
  return <tr key={field.key}>
    <th>
      {(() => { inputField ? field.label : field.label_confirm })()}
      {(() => {
        if (inputField) {
          return field.label
        } else {
          return field.label_confirm
        }
      })()}
      {(() => {
        if (field.required) {
          return <span class="text-required">{formSettings.form_text.required}</span>
        }
      })()}
    </th>
    <td>
      {(() => {
        if (field.prefix !== undefined) {
          return field.prefix + " "
        }
      })()}
      {inputField ? (() => {
        // 入力画面での描画処理
        if (field.key === "email") {
          let setEmail = () => {
            var email =  [$('[name="email_address"]').val(), $('[name="email_domain"]').val()]
            $('[name="email"]').val(JSON.stringify(email))
          }
          return <React.Fragment>
              <input type="text" name="email_address" size={field.size[0]} placeholder={field.placeholder[0]}
                defaultValue={form[field.key] ? JSON.parse(form[field.key])[0] : ""}
                onBlur={setEmail} />
              <span> @ </span>
              <input type="text" name="email_domain" size={field.size[1]} placeholder={field.placeholder[1]}
                defaultValue={form[field.key] ? JSON.parse(form[field.key])[1] : ""}
                onBlur={setEmail} />
              <input type="hidden" name="email" defaultValue={form[field.key]} />
            </React.Fragment>
        } else if (field.key === "email_confirm") {
          let setEmailConfirm = () => {
            var email =  [$('[name="email_address_confirm"]').val(), $('[name="email_domain_confirm"]').val()]
            $('[name="email_confirm"]').val(JSON.stringify(email))
          }
          let preventPaste = (e) => {
              event.preventDefault();
              alert(formSettings.form_text.prevent_paste);
          };
          return <React.Fragment>
              <input type="text" name="email_address_confirm" size={field.size[0]} placeholder={field.placeholder[0]}
                defaultValue={form[field.key] ? JSON.parse(form[field.key])[0] : ""}
                onBlur={setEmailConfirm}
                onPaste={preventPaste} />
              <span> @ </span>
              <input type="text" name="email_domain_confirm" size={field.size[1]} placeholder={field.placeholder[1]}
                defaultValue={form[field.key] ? JSON.parse(form[field.key])[1] : ""}
                onBlur={setEmailConfirm}
                onPaste={preventPaste} />
              <input type="hidden" name="email_confirm" defaultValue={form[field.key]} />
            </React.Fragment>
        } else switch(field.type) {
          case 'text':
//            return <input type="text" name={field.key} defaultValue={form[field.key]} 
            return <input type="text" name={field.key} defaultValue={form[field.key] ? form[field.key] : Encode(GetParam(field.key),field.key)} 
              size={field.size} placeholder={field.placeholder} />
          case 'textarea':
//            return <textarea name="message" defaultValue={form.message} />
            return <textarea name="message" defaultValue={form.message ? form.message : Encode(GetBreakedText(GetParam(field.key)),field.key) } />
          case 'select':
            // 未選択（選択してください）のoption(jquery)
//            return <select name={field.key} defaultValue={form[field.key]}>/
//              <option value="">{formSettings.form_text.unselect_option}</option>
//              {(() => field.values.map((item, index) => <option key={index} value={item}>{item}</option>))()}
//            </select>
            return <select name={field.key} defaultValue={form[field.key]}>
              <option value="">{formSettings.form_text.unselect_option}</option>
              {(() => field.values.map((item, index) => {
                if (GetParam(field.key) == index) {
                  return <option key={index} value={item} selected>{item}</option>
                } else {
                  return <option key={index} value={item}>{item}</option>
                }
              }))()}
            </select>
          default:
            return null;
        } 
      })(): (() => {  
        // 確認画面での描画処理
        if (field.key === "email" || field.key === "email_confirm") {
          // メールアドレスの描画処理
          let email = JSON.parse(form[field.key])
          return email[0] + "@" + email[1]
        } else switch(field.type) {
          // その他の描画処理
          case 'textarea':
            return form[field.key].split('\n').map((item, index) => (
                {
                  text: item,
                  id: index
                }
              )).map(item => (
                <span key={item.id}>
                  {item.text}
                  <br />
                </span>
              ));
          default:
            return form[field.key];
        }
      })()}
      {inputField && errors[field.key].length ? getValidationErrorMessage(formSettings.validation_messages, errors[field.key]): null}
    </td>
  </tr>
}

export const GetBrText = (text) => {
  return text.split("\n").map(l => <React.Fragment>{l}<br/></React.Fragment>)
}

// 改行処理
export const GetBreakedText = (text) => {
  if (text) return text.split("\\n").join('\n')
  else ""
}

// お問い合わせ内容／ファナック商品／件名／本文
// リクエストパラメータ取得／設定処理
export const GetParam = (key) => {

    // お問い合わせ内容／ファナック商品／件名／本文項目のみ有効
    if( key === "inquiry_type" || key === "product_type" || key === "subject" || key === "message" ) {

        var urlParamStr = window.location.search
        if (!urlParamStr) return null;
        urlParamStr = urlParamStr.substring(1)

        // 先頭パラメータの=までの文字数を取得
        var value = urlParamStr.indexOf('=');
        var value3 = '';
        var value4 = '';

        if( value != -1 ) {
            // 先頭パラメータのみ切り取る
            value3 = urlParamStr.substr( 0, value);
            // 先頭パラメータ以降を切り取る
            value4 = urlParamStr.slice(value+1);
        }

        if( value3 === key ) {
            if (value3) {
                // 先頭パラメータ以外のパラメータ名を除外
                return GetSplit(value4);
            } else {
                return null;
            }
        } else {
            var cut_str = '&'+key;

            if( urlParamStr.indexOf(cut_str) != -1 ) {
                var value2 = urlParamStr.slice(urlParamStr.indexOf(cut_str)+cut_str.length+1);
                // 先頭パラメータ以外のパラメータ名を除外
                return GetSplit(value2);;
            } else {
                return null;
            }
        }

    } else { return null; }
}

// 値中の全&パラメータを切り取る
export const GetSplit = (text) => {
    var value1 = text;
    var value2 = '';

    if( value1.search('&inquiry_type') != -1 ) {
        value2 = value1.split('&inquiry_type');
        value1 = value2[0];
    }
    if( value1.search('&product_type') != -1 ) {
        value2 = value1.split('&product_type');
        value1 = value2[0];
    }
    if( value1.search('&subject') != -1 ) {
        value2 = value1.split('&subject');
        value1 = value2[0];
    }
    if( value1.search('&message') != -1 ) {
        value2 = value1.split('&message');
        value1 = value2[0];
    }

    return value1;
}

// 文字列をデコード
export const Encode = (text, key) => {

    if (text) { 
        var dat = '';
     try {
        // URLデコード処理
        dat = decodeURIComponent( text );
     } catch(e) {
        // 異常の場合は空文字に設定。
        dat = '';
     }

     // 件名の場合は文字数チェック
     if( key === "subject" ) {
        if( dat.length > 100 ) {
            // 100文字以上は切り捨て
            dat = dat.substr(0,100);
        }
     } else
     // 本文の場合は文字数チェック
     if( key === "message" ) {
        if( dat.length > 500 ) {
            // 500文字以上は切り捨て
            dat = dat.substr(0,500);
        }
     }
     return dat;
  }
  else { "" }
}
